import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getChatParticipant, getLocalParticipant } from '../../../base/participants';
import { connect } from "../../../base/redux";
import RightHeader from "../../../base/right-menu/RightHeader";
import { closeChat, sendMessage, setPrivateMessageRecipient, setSendFileList } from "../../actions";
import ChatBody from "./ChatBody";
import ChatFooter from "./ChatFooter";

function ChatLayout({
    dispatch, open, handlerOpen,
    messages, nickname, participant
}) {
    const handlerChatMessage = (newChat, recipientList) => {
        const message = newChat && newChat.trim() !== "" ? newChat : false;
        if (message) {
            const recipient = setRecipient(recipientList);
            dispatch(setPrivateMessageRecipient(recipient));

            const data = {
                type: 'text',
                uuid: uuidv4(),
                content: message,
                recipient,
                displayName: nickname
            };

            dispatch(sendMessage(data));            
        }
    }

    const handlerChatFile = (newFile, recipientList) => {
        if (newFile) {
            const recipient = setRecipient(recipientList);
            dispatch(setPrivateMessageRecipient(recipient));

            dispatch(setSendFileList(newFile));
        }
    }

    const setRecipient = recipientList => {
        try {
            let recipient = new Array();
            recipientList.forEach((name, id) => {
                recipient.push({ id, name });
            });
            return recipient;
            
        } catch (e) {
            return new Array();
        }
    }

    const handlerClose = () => {
        dispatch(closeChat());
    }

    return (
        <>
            <RightHeader name="chat" open={open} handlerOpen={handlerOpen} handlerClose={handlerClose} />
            { open && <>
                <ChatBody messages={messages} /> 
                <ChatFooter participant={participant}
                    handlerChatMessage={handlerChatMessage}
                    handlerChatFile={handlerChatFile}
                />
            </> }
        </>
    )
}

function _mapStateToProps(state) {
    const { messages } = state['features/chat'];
    const local = getLocalParticipant(state);
    const nickname = local ? local.nickname : null;
    const participant = getChatParticipant(state);

    return {
        messages, nickname, participant
    }
}


export default connect(_mapStateToProps)(ChatLayout);